import _ from 'lodash'

import { adUnitsAttributesMapper } from 'features/inventory/domain/components/ProductAdUnitsTable/utils'
import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/graphql/utils'
import { Schema } from '../../schema'
import { Variables } from './api/types'

export const mapper = (data: Schema, ability: Ability): Variables => {
  const {
    adUnitsAttributes,
    baseAdUnitPath,
    cacheAndReusePrebidBids,
    domainId,
    unfilledRecoveryEnabled,
  } = data

  const constantFields: Pick<
    Variables,
    'adUnitsAttributes' | 'cacheAndReusePrebidBids' | 'domainId' | 'unfilledRecoveryEnabled'
  > = {
    adUnitsAttributes: adUnitsAttributesMapper<'unfilledRecoveryEnabled'>(
      adUnitsAttributes,
      'unfilledRecoveryEnabled',
    ),
    cacheAndReusePrebidBids,
    domainId,
    unfilledRecoveryEnabled,
  }

  const variableFields: Pick<Variables, 'baseAdUnitPath'> = {
    baseAdUnitPath,
  }

  return {
    ...constantFields,
    ..._.omit(
      variableFields,
      fieldsToOmit<Variables>({
        baseAdUnitPath: ability.cannot('update', 'DomainField-baseAdUnitPath'),
      }),
    ),
  }
}
